module.exports = __webpack_public_path__ + "static/img/04.81583f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/04.jpg
// module id = zqAS
// module chunks = 1